<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [container]="container"
  [draggableEnabled]="false"
  [showToolbar]="false"
  [showModalTitle]="false"
  [closeBtnEnabled]="false"
  [closeOutsideClickEnabled]="false"
  [overlayMask]="overlayMask"
  shapeType="circle"
  width="auto"
  height="auto"
  [modalVerticalAlignment]="modalVerticalAlignment"
  [modalHorizontalAlignment]="modalHorizontalAlignment"
  [containerVerticalAlignment]="containerVerticalAlignment"
  [containerHorizontalAlignment]="containerHorizontalAlignment"
  [(posX)]="posX"
  [(posY)]="posY"
>
  <ng-template modalContent>
    <app-loading-indicator class="loading-indicator"></app-loading-indicator>
  </ng-template>
</app-modal>
